<template>
    <div>
        <v-card class="pa-3 mx-4 mt-3">
            <v-layout
                row
                class="px-3 pt-3 pb-2 mb-2 ma-1"
                style="border: 2px solid #43a047; border-radius: 6px;"
            >
                <v-layout column style="width: 50%">
                    <div class="mb-2">
                        <v-layout row class="pa-0">
                            <div class="font-weight-medium mr-3">
                                {{ broadcast.broadcastName }}
                            </div>

                            <div class="cyan caption pa-1" style="color: #fff">
                                {{ broadcast.accountsSource }}
                            </div>

                            <div
                                style="background-color: #fdb400"
                                class="ml-2 caption pa-1 white--text"
                                v-if="broadcast.broadcastStatus != 'COMPLETED'"
                            >
                                {{ broadcast.broadcastStatus }}
                            </div>
                        </v-layout>
                        <div class="body-1">Name</div>
                    </div>
                    <div class="mb-2">
                        <div class="font-weight-medium">
                            {{ broadcast.fromNumber }}
                        </div>
                        <div class="body-1">From Email</div>
                    </div>
                    <div class="mb-2">
                        <div class="font-weight-medium">
                            {{ broadcast.userName }}
                        </div>
                        <div class="body-1">User</div>
                    </div>
                    <v-layout row>
                        <div class="mb-2">
                            <div class="font-weight-medium">
                                {{ broadcast.date | time }}
                            </div>
                            <div class="body-1">Date</div>
                        </div>
                        <div
                            class="mb-0 ml-4"
                            v-if="broadcast.date != broadcast.broadcastTime"
                        >
                            <div class="font-weight-medium">
                                {{ broadcast.broadcastTime | time }}
                            </div>
                            <div class="body-1">Broadcast Time</div>
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout column style="width: 50%">
                    <div class="mb-3">
                        <div class="font-weight-medium">
                            {{ broadcast.totalCount }}
                        </div>
                        <div class="body-1">Total Calls</div>
                    </div>
                    <div class="mb-3">
                        <div class="font-weight-medium">
                            {{ broadcast.completed || 0 }}
                        </div>
                        <div class="body-1">Completed</div>
                    </div>
                </v-layout>
            </v-layout>
        </v-card>

        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :beforeSetupGrid="beforeSetupGrid"
            name="broadcast-emails-logs-new"
            :isRemotePaging="false"
            :isRemoteSorting="false"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Emails",
        url: "",
        broadcast: "",
        intervalID: "",

        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        case "UNKNOWN":
                            return "mdi-message-question";
                        case "SENT":
                            return "mdi-message-text";
                        case "FAILED":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                        case "UNDELIVERED":
                            return "#f35123";
                        case "QUEUED":
                        case "PENDING":
                            return "#fdb400";
                        case "SENT":
                            return "success";
                        case "UNKNOWN":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountId",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.loadBroadcast();
    },
    mounted() {
        this.intervalID = setInterval(() => {
            this.loadBroadcast();

            if (this.$refs && this.$refs.grid) {
                this.$refs.grid.reloadGrid();
            }
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.intervalID);
    },
    methods: {
        beforeSetupGrid() {
            this.url = "broadcastEmails?broadcastID=" + this.$route.params.id;
        },
        async loadBroadcast() {
            const response = await this.$http.get(
                `/odata/broadcastReport?status=&$filter=(id eq ${
                    this.$route.params.id
                })`
            );

            const broadcast = response.value[0];

            this.broadcast = broadcast;
        },
        async onRowClicked(row) {},
        getMessagesInProcess() {
            return this.broadcast.totalCount - (this.broadcast.completed || 0);
        },
        getBroadcastStatuses() {
            return this.broadcast.statuses;
        },
        reuseBroadcast(broadcast) {
            this.$router.push({
                name: "Broadcasts",
                query: {
                    reuseBroadcast: true,
                    broadcastID: this.broadcast.id,
                },
            });
            // this.$refs.broadcastDialog.loadDraft(broadcast.id.toString(), true);
        },
    },
};
</script>
<style></style>
